<p-table #newtable [value]="workbookRows" [columns]="workbookColumns"
      [showJumpToPageInput]="!multiSelect" styleClass="p-datatable-gridlines floatthead-result"
      [lazy]="true" (onLazyLoad)="getTableWithPagination($event)" [paginator]="true"
      [rows]="pageSize" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
      [rowsPerPageOptions]="tableShowMore"
      [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'" [scrollable]="true"
      [resizableColumns]="true" 
      appFloatThead
      [forceReflow]="forceReflow" [showFloatHeader]="showFloatHeader"
      floatTableClassRef="floatthead-result"
      dataKey="rowNumber" 
      [(selection)]="selectedRowForConversion"
      selectionPageOnly="true"
      [paginatorDropdownAppendTo]="'body'"
      >
      <ng-template pTemplate="caption">
        <div class="p-d-flex p-ai-center">
            <!-- Workbook title -->
            <p-breadcrumb [model]="breadcrumbItems" class="breadcrumb-custom-icons"></p-breadcrumb>
        </div>
    </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <!-- Checkbox for Select All -->
          <th pResizableColumn *ngIf="workbookRows?.length && multiSelect" style="border-right: 1px solid var(--primary-color);">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th pResizableColumn *ngIf="workbookRows?.length" style="border-right: 1px solid var(--primary-color);"></th>
          <ng-container *ngFor="let col of columns">
            <ng-container *ngIf="col.enable">
              <th pResizableColumn style="border-right: 1px solid var(--primary-color);">
              {{ col.name }}
            </th>
             </ng-container> 
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
        <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: rowData, columns: columns, rowIndex: i }">
        </ng-container>
      </ng-template>
      <ng-template #rowTemplate let-workbookRow let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="workbookRow">
          <!-- Checkbox for individual row selection -->
          <td *ngIf="multiSelect">
            <p-tableCheckbox [value]="workbookRow" [binary]="true"></p-tableCheckbox>
          </td>
          <td  >{{ rowIndex + 1 }}</td>
          <ng-container *ngFor="let col of columns">
            <ng-container *ngIf="col.enable">
              <td>
            <app-shared-workbook-cell  [col]="col" [workbookRow]="workbookRow"></app-shared-workbook-cell>
          </td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="workbookColumns?.length + 1">
            <div class="p-text-center">No Data Available</div>
          </td>
        </tr>
      </ng-template>
    </p-table>    